// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__ulUxK","loader":"loader_loader__weu8n"};